var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V20H20V0ZM7.89605 3.84848C7.89605 3.38889 8.26727 3 8.74456 3C11.9088 3 14.472 5.56313 14.472 8.70958C14.472 9.16918 14.1008 9.55807 13.6235 9.55807C13.1639 9.55807 12.775 9.18686 12.775 8.70958C12.775 6.48232 10.9719 4.67929 8.74456 4.67929C8.26727 4.67929 7.89605 4.30808 7.89605 3.84848ZM16.1515 7.8612C16.6111 7.8612 17 8.23241 17 8.70968C17 11.8561 14.4368 14.4193 11.2726 14.4193C10.813 14.4193 10.4241 14.0481 10.4241 13.5708C10.4241 13.1112 10.7953 12.7223 11.2726 12.7223C13.4999 12.7223 15.303 10.9193 15.303 8.69201C15.303 8.25009 15.6919 7.8612 16.1515 7.8612ZM12.1217 16.1515C12.1217 16.6111 11.7505 17 11.2732 17C8.10898 17 5.54578 14.4369 5.54578 11.2904C5.54578 10.8308 5.917 10.4419 6.39429 10.4419C6.8539 10.4419 7.2428 10.8131 7.2428 11.2904C7.2428 13.5177 9.04588 15.3207 11.2732 15.3207C11.7505 15.3207 12.1217 15.6919 12.1217 16.1515ZM3.84851 12.1388C3.3889 12.1388 3 11.7676 3 11.2903C3 8.14386 5.56321 5.58073 8.72744 5.58073C9.18705 5.58073 9.57595 5.95195 9.57595 6.42922C9.57595 6.88881 9.20473 7.2777 8.72744 7.2777C6.5001 7.2777 4.69702 9.08073 4.69702 11.308C4.67934 11.7499 4.30812 12.1388 3.84851 12.1388Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElement);
export default __webpack_public_path__ + "static/media/icon_element.40a06aafd2566854f1ddef639eb753aa.svg";
export { ForwardRef as ReactComponent };